<a
  [matButton]="buttonStyle()"
  uiNavLink
  [link]="link()"
  [color]="buttonStyle()"
  [class]="buttonStyle()"
>
  <ng-content></ng-content>
</a>
